import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../contexts/LanguageContext';

const Container = styled.div`
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 16px 64px;
  @media (min-width: 640px) { padding: 40px 24px 80px; }
`;

const Title = styled.h1`
  font-size: 1.3rem;
  font-weight: 700;
  color: ${(p) => p.theme.colors.text};
  margin: 0 0 32px 0;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Tr = styled.tr`
  border-bottom: 1px solid ${(p) => p.theme.colors.border};
`;

const Th = styled.th`
  text-align: left;
  vertical-align: top;
  padding: 14px 12px;
  font-size: 0.85rem;
  font-weight: 600;
  color: ${(p) => p.theme.colors.textSecondary};
  white-space: nowrap;
  width: 160px;

  @media (max-width: 520px) {
    width: 110px;
    font-size: 0.8rem;
    padding: 10px 8px;
  }
`;

const Td = styled.td`
  padding: 14px 12px;
  font-size: 0.85rem;
  color: ${(p) => p.theme.colors.text};
  line-height: 1.7;

  @media (max-width: 520px) {
    font-size: 0.8rem;
    padding: 10px 8px;
  }
`;

const LastUpdated = styled.p`
  font-size: 0.75rem;
  color: ${(p) => p.theme.colors.textMuted};
  margin-top: 32px;
`;

function TokushohoPage() {
  const { t } = useLanguage();

  return (
    <Container>
      <Title>{t('特定商取引法に基づく表記', 'Specified Commercial Transactions Act')}</Title>

      <Table>
        <tbody>
          <Tr>
            <Th>{t('販売業者', 'Seller')}</Th>
            <Td>Workwrite LLC</Td>
          </Tr>
          <Tr>
            <Th>{t('運営責任者', 'Representative')}</Th>
            <Td>Kazuki Niidome</Td>
          </Tr>
          <Tr>
            <Th>{t('所在地', 'Address')}</Th>
            <Td>{t('請求があった場合に遅滞なく開示いたします。', 'Disclosed upon request without delay.')}</Td>
          </Tr>
          <Tr>
            <Th>{t('連絡先', 'Contact')}</Th>
            <Td>info@workwrite.co.jp</Td>
          </Tr>
          <Tr>
            <Th>{t('販売価格', 'Pricing')}</Th>
            <Td>
              {t(
                '月額プラン: ¥980（税込）/ レポート単品購入: ¥300（税込）',
                'Monthly: ¥980 (tax incl.) / Single report: ¥300 (tax incl.)'
              )}
            </Td>
          </Tr>
          <Tr>
            <Th>{t('支払方法', 'Payment')}</Th>
            <Td>{t('クレジットカード（Stripe決済）', 'Credit card (via Stripe)')}</Td>
          </Tr>
          <Tr>
            <Th>{t('支払時期', 'Payment Timing')}</Th>
            <Td>
              {t(
                'サブスクリプション：申込時に初回決済、以後毎月自動更新。単品購入：購入時に即時決済。',
                'Subscription: charged at sign-up, auto-renewed monthly. One-time purchase: charged immediately.'
              )}
            </Td>
          </Tr>
          <Tr>
            <Th>{t('サービス提供時期', 'Delivery')}</Th>
            <Td>
              {t(
                '決済完了後、直ちにサービスをご利用いただけます。',
                'Service is available immediately after payment.'
              )}
            </Td>
          </Tr>
          <Tr>
            <Th>{t('返品・キャンセル', 'Cancellation')}</Th>
            <Td>
              {t(
                'サブスクリプションはいつでも解約可能です。解約後も契約期間終了まで引き続きご利用いただけます。デジタルコンテンツの性質上、レポート単品購入後の返金はいたしかねます。',
                'Subscriptions can be canceled anytime. Access continues until the end of the billing period. Due to the nature of digital content, single report purchases are non-refundable.'
              )}
            </Td>
          </Tr>
          <Tr>
            <Th>{t('動作環境', 'Requirements')}</Th>
            <Td>
              {t(
                'インターネット接続環境、最新のWebブラウザ（Chrome, Safari, Firefox, Edge）',
                'Internet connection, modern web browser (Chrome, Safari, Firefox, Edge)'
              )}
            </Td>
          </Tr>
        </tbody>
      </Table>

      <LastUpdated>{t('最終更新日: 2026年2月23日', 'Last updated: February 23, 2026')}</LastUpdated>
    </Container>
  );
}

export default TokushohoPage;
